import type { ReactElement } from 'react';
import { FAQ_ITEMS } from './faq-items';
import { QuoteFaqItem } from './quote-faq-item';

/** 견적문의 자주 묻는 질문 — 넓은 화면은 왼쪽 제목, 오른쪽 질문 목록. */
export const QuoteGuideFaq = (): ReactElement => (
  <section
    aria-labelledby="quote-faq-heading"
    className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-16"
  >
    <header className="flex flex-col gap-4">
      <h2
        id="quote-faq-heading"
        className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
      >
        <span aria-hidden>FAQ</span>
        <span className="sr-only">자주 묻는 질문</span>
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        견적 전에 많이 묻는 내용이에요.
      </p>
    </header>

    <ul className="border-t border-foreground">
      {FAQ_ITEMS.map((item) => (
        <QuoteFaqItem key={item.question} item={item} />
      ))}
    </ul>
  </section>
);
